export default "__VITE_ASSET__8PFdFAao__"